import {
  WarningIcon
} from "./chunk-EBVYP6SE.mjs";
import {
  SuccessIcon
} from "./chunk-LGGUHVXO.mjs";
import {
  ErrorIcon
} from "./chunk-T7FOZNCY.mjs";
import {
  InfoIcon
} from "./chunk-HJHOJHZ7.mjs";
import {
  Cross
} from "./chunk-STJ6A5EM.mjs";

// src/notification/src/notification.tsx
import { cva, cx } from "class-variance-authority";
import { jsx, jsxs } from "react/jsx-runtime";
var REQUIRES_LOCALISATION_CLOSE_BUTTON_LABEL = "Close";
var notificationVariants = cva("grid gap-3 rounded p-3 text-base", {
  variants: {
    status: {
      error: ["bg-state-negative-background"],
      info: ["bg-state-info-background"],
      success: ["bg-state-positive-background"],
      warning: ["bg-state-warning-background"]
    }
  }
});
var iconVariants = cva(null, {
  variants: {
    status: {
      error: ["text-state-negative-graphics"],
      info: ["text-state-info-graphics"],
      success: ["text-state-positive-graphics"],
      warning: ["text-state-warning-graphics"]
    }
  }
});
var STATUS_TO_ICON = {
  error: /* @__PURE__ */ jsx(ErrorIcon, {}),
  info: /* @__PURE__ */ jsx(InfoIcon, {}),
  success: /* @__PURE__ */ jsx(SuccessIcon, {}),
  warning: /* @__PURE__ */ jsx(WarningIcon, {})
};
var Notification = ({
  actionable,
  children,
  omitRole = false,
  role = "alert",
  status,
  testId,
  title,
  onClose
}) => /* @__PURE__ */ jsxs(
  "div",
  {
    className: notificationVariants({
      className: {
        // [icon, content, close icon]
        "grid-cols-[min-content,_1fr,_min-content]": onClose,
        // [icon, content]
        "grid-cols-[min-content,_1fr]": !onClose,
        "pr-4": !onClose
      },
      status
    }),
    "data-testid": testId,
    role: omitRole ? void 0 : role,
    children: [
      /* @__PURE__ */ jsx("span", { className: iconVariants({ status }), children: STATUS_TO_ICON[status] }),
      /* @__PURE__ */ jsxs(
        "div",
        {
          className: cx("grid max-w-prose content-center gap-1", {
            "text-surface-body": title,
            // when there isn't a title, darken the text
            "text-surface-dark": !Boolean(title)
          }),
          children: [
            Boolean(title) ? /* @__PURE__ */ jsx("span", { className: "text-base-strong text-surface-dark", children: title }) : null,
            children,
            Boolean(actionable) ? /* @__PURE__ */ jsx("span", { className: "mt-1 grid gap-3", children: actionable }) : null
          ]
        }
      ),
      onClose ? /* @__PURE__ */ jsx(
        "button",
        {
          "aria-label": REQUIRES_LOCALISATION_CLOSE_BUTTON_LABEL,
          className: "self-start",
          type: "button",
          onClick: onClose,
          children: /* @__PURE__ */ jsx(Cross, {})
        }
      ) : null
    ]
  }
);

export {
  Notification
};
